let ctx;

function ensureCtx() {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

function tone(freq, startAt, dur = 0.16, vol = 0.25) {
  const c = ensureCtx();
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = "sine";
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0, c.currentTime + startAt);
  gain.gain.linearRampToValueAtTime(vol, c.currentTime + startAt + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.001, c.currentTime + startAt + dur);
  osc.connect(gain).connect(c.destination);
  osc.start(c.currentTime + startAt);
  osc.stop(c.currentTime + startAt + dur + 0.05);
}

export function isMuted() {
  return localStorage.getItem("bp_muted") === "1";
}

export function setMuted(m) {
  localStorage.setItem("bp_muted", m ? "1" : "0");
}

export function playGeneralChime() {
  if (isMuted()) return;
  try {
    tone(880, 0);
    tone(660, 0.18);
  } catch (e) {
    console.debug("audio unavailable", e?.message);
  }
}

export function playOrderChime() {
  if (isMuted()) return;
  try {
    tone(587, 0, 0.14, 0.3);
    tone(740, 0.16, 0.14, 0.3);
    tone(880, 0.32, 0.22, 0.3);
  } catch (e) {
    console.debug("audio unavailable", e?.message);
  }
}
